import React from 'react'
import Layout from '../components/layout';
import styled from 'styled-components'
import {sizes, colors, fonts, breakpoints} from '../components/css-variables'
import buckyBg from '../images/404_bucky_bg.jpg'
import SearchModal from "../components/parts/SearchModal"
import Search from "../svg/search.svg"
import Cloud from '../svg/red_cloud.svg'
import SmallCloud from '../svg/small_red_cloud.svg'

const Page404 = () => {
    if (typeof window !== "undefined" && window.location.href.includes('chapters.uwalumni.com')) {
        const fixedUrl = window.location.href.replace('chapters.uwalumni.com','www.uwalumni.com')
        window.location.replace(fixedUrl)
      }

    const OuterWrapper = styled.div`
        min-height: 650px;
        background-image: url(${buckyBg});
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: bottom center;
        .cloud{
            display: none;
        }
        @media screen and ${breakpoints.tabletL} {
            min-height: 780px;
        }
        @media screen and ${breakpoints.laptopS} {
            min-height: 900px;
            .cloud{
                display: block;
            }
        }
        @media screen and ${breakpoints.laptopL} {
            min-height: 1100px;
        }
    `
    const InnerWrapper = styled.div`
        margin:100px auto 50px;
        max-width: 300px;
        min-height:400px;
        @media screen and ${breakpoints.tabletS} {
            max-width: 534px;
        }
        @media screen and ${breakpoints.laptopS} {
            max-width:712px;
        }
        h1 {
            color: ${colors.titleColor};
            font-family: ${fonts.eaves};
            font-weight: bold;
            font-style: italic;
            margin-bottom: ${sizes.s32};
            text-align: center;
        }
        h1:after {
            display: block;
            margin: 30px auto;
            position: relative;
            left: calc(0 - 30px);
            height: 0.444rem;
            width: calc(3.778rem);
            background-color: ${colors.titleColor};
            content: "";
            
        }
        p a {
            color:${colors.titleColor};
        }
        .search {
            width: 43px;
            display: flex;
            align-items: center;
            a {
              display: block;
              width: 19px;
              height: 19px;
              margin-bottom: 4px;
              background-color: ${colors.navMenuBlack};
              mask: url(${Search});
              &:hover {
                background-color: ${colors.buttonRed};
                cursor: pointer;
              }
            }
          }
    
    `
    return(
        <Layout title="404 - Item Not Found" url="/404">
            <OuterWrapper>
            <InnerWrapper>
                <h1>Oops, Something Went Wrong</h1>
                <p>The page you were looking for was not found or the address is outdated.
                    Looking for <a href="/events">events</a>? Want to <a href="/news">browse our stories</a>?
                    Want to find your <a href="/waa-groups">chapter or group</a>?</p>
                <p>You can use the menu or <a href="/search">site search</a> to get where you want to go.
                    You can reach out at any time using our chat feature or you can check out our <a href="/about/customer-service-faq/">frequently asked questions</a>.
                </p>
                <SearchModal is404 />
            </InnerWrapper>
            <img src={Cloud} class="cloud" alt="red cloud outline" width="460" height="119" style={{top: "160px", left: "-200px", position: "absolute"}}/>
            <img src={SmallCloud} class="cloud" alt="red cloud outline" width="300" height="78" style={{top: "275px", right: "-75px", position: "absolute"}}/>
            </OuterWrapper>
        </Layout>
    )
}
export default Page404